import { createSlice } from "@reduxjs/toolkit"
import {
  createFleet,
  createMake,
  createModel,
  deleteMake,
  deleteModel,
  deleteVehicle,
  fetchAllMakes,
  fetchAllModels,
  fetchVehicles,
  updateVehicle
} from "../actions/fleet/fleet-action"

const initfleet = {
  fleet: [],
  models: [],
  make: [],
  success: false,
  error: false,
  loading: false,
  message: "",
  postedData: {}
}
const FleetSlice = createSlice({
  name: "fleet",
  initialState: initfleet,
  reducers: {
    initData: (state) => {
      return {
        ...state,
        fleet: [],
        models: [],
        make: [],
        success: false,
        error: false,
        message: "",
        loading: false
      }
    },
    showJsonDataOnItem: (state, action) => {
      return { ...state, postedData: action?.payload }
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(createFleet.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = false
        state.message = ""
      })
      .addCase(createFleet.fulfilled, (state, action) => {
        if (!Array.isArray(state.fleet)) {
          state.fleet = []
        }
        state.fleet = [
          ...state.fleet.filter((item) => item !== null),
          action.payload
        ]
        state.loading = false
        state.success = true
        state.error = false
        state.message = "Vehicle added successfully"
      })
      .addCase(createFleet.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = true
        state.message = action.payload?.message || "An error occurred"
      })

      .addCase(fetchVehicles.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchVehicles.fulfilled, (state, action) => {
        const vehiclesData = action.payload.data || action.payload
        state.fleet = Array.isArray(vehiclesData) ? vehiclesData : []
        state.loading = false
        state.error = false
      })
      .addCase(fetchVehicles.rejected, (state, action) => {
        state.loading = false
        state.error = true
        state.message = action.payload?.message || "Failed to fetch vehicles"
      })

      .addCase(deleteVehicle.fulfilled, (state, action) => {
        state.fleet = state.fleet.filter(
          (vehicle) => vehicle.id !== action.payload
        )
        state.message = "Vehicle deleted successfully"
      })

      .addCase(updateVehicle.fulfilled, (state, action) => {
        const index = state.fleet.findIndex(
          (vehicle) => vehicle.id === action.payload.id
        )
        if (index !== -1) {
          state.fleet[index] = action.payload
        }
        state.message = "Vehicle updated successfully"
      })

      .addCase(createModel.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = false
        state.message = ""
      })

      .addCase(createModel.fulfilled, (state, action) => {
        if (!Array.isArray(state.models)) {
          state.models = []
        }
        state.models = [
          ...state.models.filter((item) => item !== null),
          {
            ...action.payload,
            images: action.payload.images || []
          }
        ]
        state.loading = false
        state.success = true
        state.error = false
        state.message = "Model added successfully"
      })

      .addCase(createModel.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = true
        state.message = action.payload?.message || "Failed to create model"
      })

      //make

      .addCase(createMake.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = false
        state.message = ""
      })
      .addCase(createMake.fulfilled, (state, action) => {
        if (!Array.isArray(state.make)) {
          state.make = []
        }
        state.make = [
          ...state.make.filter((item) => item !== null),
          action.payload
        ]
        state.loading = false
        state.success = true
        state.error = false
        state.message = "Make added successfully"
      })
      .addCase(createMake.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = true
        state.message = action.payload?.message || "Failed to create make"
      })

      //list

      .addCase(fetchAllMakes.pending, (state) => {
        state.loading = true
        state.error = null
        state.message = null
      })
      .addCase(fetchAllMakes.fulfilled, (state, action) => {
        state.loading = false
        state.make = action.payload
        state.error = null
        state.message = null
      })
      .addCase(fetchAllMakes.rejected, (state, action) => {
        state.loading = false
        state.error = true
        state.message = action.payload?.message || "Failed to fetch users"
      })

      .addCase(deleteMake.fulfilled, (state, action) => {
        state.make = state.make.filter((make) => make.id !== action.payload)
        state.message = "Make deleted successfully"
      })

      //models

      .addCase(fetchAllModels.pending, (state) => {
        state.loading = true
        state.error = null
        state.message = null
      })
      .addCase(fetchAllModels.fulfilled, (state, action) => {
        state.loading = false
        state.models = action.payload
        state.error = null
        state.message = null
      })
      .addCase(fetchAllModels.rejected, (state, action) => {
        state.loading = false
        state.error = true
        state.message = action.payload?.message || "Failed to fetch users"
      })

      //delete model

      .addCase(deleteModel.fulfilled, (state, action) => {
        state.models = state.models.filter(
          (model) => model.id !== action.payload
        )
        state.message = "Model deleted successfully"
      })
  }
})
export const { initData, showJsonDataOnItem } = FleetSlice.actions
export default FleetSlice.reducer
